// src/utils/dialog.ts
//
// 앱 전역에서 사용하는 커스텀 다이얼로그 API.
// 브라우저 기본 window.alert / window.confirm / window.prompt 를 대체.
// 호출처는 await 로 결과를 받아 처리한다.
import { dialogStore } from '../stores/dialog.store.ts';

export type AlertOptions = {
  title?: string;
  confirmLabel?: string;
};

export type ConfirmOptions = {
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
};

export type PromptOptions = {
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  placeholder?: string;
  defaultValue?: string;
};

export function showAlert(message: string, options?: AlertOptions): Promise<void> {
  return new Promise((resolve) => {
    dialogStore.getState().push({
      kind: 'alert',
      title: options?.title,
      message,
      confirmLabel: options?.confirmLabel ?? 'OK',
      cancelLabel: '',
      destructive: false,
      resolve,
    });
  });
}

export function showConfirm(message: string, options?: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    dialogStore.getState().push({
      kind: 'confirm',
      title: options?.title,
      message,
      confirmLabel: options?.confirmLabel ?? 'OK',
      cancelLabel: options?.cancelLabel ?? 'Cancel',
      destructive: !!options?.destructive,
      resolve,
    });
  });
}

export function showPrompt(message: string, options?: PromptOptions): Promise<string | null> {
  return new Promise((resolve) => {
    dialogStore.getState().push({
      kind: 'prompt',
      title: options?.title,
      message,
      confirmLabel: options?.confirmLabel ?? 'OK',
      cancelLabel: options?.cancelLabel ?? 'Cancel',
      destructive: false,
      placeholder: options?.placeholder,
      defaultValue: options?.defaultValue ?? '',
      resolve,
    });
  });
}
